import { render, staticRenderFns } from "./balance.vue?vue&type=template&id=355b43ca&scoped=true&"
import script from "./balance.vue?vue&type=script&lang=js&"
export * from "./balance.vue?vue&type=script&lang=js&"
import style0 from "./balance.vue?vue&type=style&index=0&id=355b43ca&prod&lang=less&"
import style1 from "./balance.vue?vue&type=style&index=1&id=355b43ca&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355b43ca",
  null
  
)

export default component.exports